var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-tip",style:({ backgroundColor: _vm.backgroundColor })},[_c('div',{staticClass:"icon-wrapper"},[_c('img',{attrs:{"src":_vm.iconPath}})]),_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }